// extracted by mini-css-extract-plugin
export default {"dayGroupHeader":"DayGroupHeader_dayGroupHeader__3cPWx","headingText":"DayGroupHeader_headingText__PdlTu","summaryDivider":"DayGroupHeader_summaryDivider__CslhL"};